module.exports = __webpack_public_path__ + "static/media/Ben Lafreniere.99f81714.png";